export const it_team= {
    title: 'Il mio team',
    name: 'Nome',
    email: 'Email',
    phone: 'Telefono',
    password: 'Password',
    label_password: 'Se il campo resta in bianco, la password non verrà cambiata',
    profession: 'Professione',
    insert_new_team: 'NUOVO COLLABORATORE',
    new_member: 'Nuovo Collaboratore',
    new_member_btn:'Nuovo membro',
    salva:'SALVA',
    remove:'RIMUOVI',

    popover_incomeTeam_title: 'Il team di questa operazione',
    popover_incomeTeam_content: '<p>Inserisci, modifica e cancella le informazioni relative al team</p>',

    popover_myTeam_title: 'Team',
    popover_myTeam_content: '<p>Inserisci, modifica e cancella le informazioni relative al team</p>',

};